module.exports = __webpack_public_path__ + "static/media/carnaval das antigas.4c83b702.JPG";